/* eslint-disable no-undef */
/* eslint-disable camelcase */
import config from '../../../../app.config.json';

declare global {
  const gtag: (a: string, b: any, c?: object) => void | undefined;
}

let configured = false;
let params: any = {};

/**
 * Ensure gtag is configured, can be called multiple times
 * but will only configure gtag within the scope of the
 * application, subsequent calls will be ignored.
 */
export const configureGtag = (newParams: any) => {
  if (typeof gtag !== 'undefined' && !configured) {
    gtag('js', new Date());
    gtag('config', config.googleAnalyticsKey, {
      send_page_view: false,
    });

    configured = true;
  }

  params = newParams;
};

export const trackPageView = () => {
  if (typeof gtag !== 'undefined') {
    gtag('event', 'page_view', {
      page_title: document.title,
      page_location: window.location.href,
      ...params,
    });
  }
};

export const trackGaEvent = (event: string, mParams: any) => {
  if (typeof gtag !== 'undefined') {
    gtag('event', event, {
      ...params,
      ...mParams,
    });
  }
};

export const trackGaLink = (event: string, location: string, page?: string) => () => {
  if (typeof gtag !== 'undefined') {
    gtag('event', event, {
      ...params,
      page,
      location,
    });
  }
};
